export function Spinner({ size = 16, className = '' }: { size?: number; className?: string }) {
  return (
    <span
      role="progressbar"
      aria-label="Loading"
      className={`inline-block rounded-full border-2 border-current border-r-transparent ${className}`}
      style={{ width: size, height: size, animation: 'spin 0.8s linear infinite' }}
    />
  );
}
